// Keep keyboard navigation within an Ordering dialog and return to its trigger.
export const orderingDialog = {
  mounted(el) {
    const previous = document.activeElement;
    const focusable = () => [...el.querySelectorAll('button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]')].filter(node => node.getClientRects().length);
    const onKey = event => {
      if (event.key !== 'Tab') return;
      const nodes = focusable();
      if (!nodes.length) { event.preventDefault(); el.focus(); return; }
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (event.shiftKey && (document.activeElement === first || !el.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !el.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    };
    el.tabIndex = -1;
    el.addEventListener('keydown', onKey);
    el._orderingCleanup = () => { el.removeEventListener('keydown', onKey); if (previous?.isConnected) previous.focus(); };
    queueMicrotask(() => (el.querySelector('input:not(:disabled)') || focusable()[0] || el).focus());
  },
  unmounted(el) { el._orderingCleanup?.(); }
};
